(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/widgets/poker-deeplink-grid/assets/javascripts/poker-deeplink-grid.js') >= 0) return;  svs.modules.push('/widgets/poker-deeplink-grid/assets/javascripts/poker-deeplink-grid.js');
"use strict";


const _svs$components$poker = svs.components.poker.common.util,
  startPokerGameTypeDeeplink = _svs$components$poker.startPokerGameTypeDeeplink,
  launchGameTypeFromStorage = _svs$components$poker.launchGameTypeFromStorage;
const getIndexInWidgetArea = node => {
  const closesWidgetArea = node.closest('.widget-area');
  let presumedIndex = null;
  closesWidgetArea.childNodes.forEach((widget, index) => {
    var _widget$firstChild;
    if (widget !== null && widget !== void 0 && (_widget$firstChild = widget.firstChild) !== null && _widget$firstChild !== void 0 && _widget$firstChild.className && widget.firstChild.className.includes('poker-deeplinks-widget')) {
      presumedIndex = index + 1;
    }
  });
  return presumedIndex;
};
const handleClick = node => {
  const _node$dataset = node.dataset,
    gamecodename = _node$dataset.gamecodename,
    impressionTracking = _node$dataset.impressionTracking;
  svs.components.analytics.trackEvent({
    category: 'Poker',
    action: 'initiate poker',
    opt_label: impressionTracking
  });
  svs.components.analytics.trackPromoClick({
    ID: svs.utils.url.getLocation().pathname,
    name: impressionTracking,
    position: getIndexInWidgetArea(node)
  });
  if (gamecodename) {
    startPokerGameTypeDeeplink(gamecodename);
  }
};
const waitForEl = selector => new Promise(resolve => {
  if (document.querySelector(selector)) {
    resolve();
    return;
  }
  const observer = new MutationObserver(() => {
    if (document.querySelector(selector)) {
      observer.disconnect();
      resolve();
    }
  });
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
});
const setupEventListener = async function () {
  let tries = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  await waitForEl('.js-poker-deeplink-grid-item-action');
  const nodes = document.querySelectorAll('.js-poker-deeplink-grid-item-action');
  if (nodes !== null && nodes !== void 0 && nodes.length) {
    nodes.forEach(node => {
      node.addEventListener('click', () => {
        handleClick(node);
      });
    });
  } else {
    setTimeout(() => {
      if (tries < 20) {
        setupEventListener(tries += 1);
      }
    }, 100);
  }
};
const init = () => {
  setupEventListener();
  launchGameTypeFromStorage();
};
setGlobal('svs.widget.poker_deeplink_grid.init', options => {
  if (options && options.model) {
    init();
  }
});

 })(window);